/**
 * Older releases registered a service worker (create-react-app). It is not used any more; make sure
 * browsers that still have it drop it, otherwise they keep serving the cached old app.
 * See also public/service-worker.js.
 */
export function unregisterServiceWorkers() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.getRegistrations()
    .then(registrations => Promise.all(registrations.map(registration => registration.unregister())))
    .catch((error: unknown) => console.warn('Could not unregister service workers', error));
}
